import { PublicClientApplication } from '@azure/msal-browser';
import { saveTokens, sessionKeys } from '../../../core/session';
import SsoClientCredentials from '../../../models/be/transport/SsoClientCredentials';
import { CustomerSsoDetails, SsoCustomer } from '../../../models/be/SsoCustomer';
import { getSsoClientToken } from '../../../core/CustomerSsoApi';

export const authenticateSSOLogin = async (ssoCustomer: CustomerSsoDetails, email: string, rememberMe: boolean) => {
	try {
		if (ssoCustomer) {
			const config = {
				auth: {
					clientId: ssoCustomer.clientId,
					authority: ssoCustomer.authority,
					redirectUri: '/'
				},
				cache: {
					cacheLocation: 'sessionStorage'
				}
			};

			const msalInstance = new PublicClientApplication(config);
			await msalInstance.initialize();
			const loginResponse = await msalInstance.acquireTokenPopup({
				scopes: [ssoCustomer.scope]
			});
			if (loginResponse.account && loginResponse.account.username === email) {
				const ssoClientCredentials: SsoClientCredentials = {
					grantType: 'sso_clients',
					ssoClientId: ssoCustomer.clientId,
					username: email,
					rememberMe
				};

				const token = await getSsoClientToken(ssoClientCredentials);
				saveTokens(token.refreshToken, token.accessToken);
				const redirectUrl = getRedirectAppUrl();
				if (redirectUrl) {
					removeRedirectAppUrl();
					return redirectUrl;
				}
				return '/candidates';
			}
			return '/';
		}
		return null;
	} catch (error) {
		if (error?.errorCode === 'user_cancelled') {
			return '/';
		}
		if (error?.errorMessage?.includes('Error opening popup window')) {
			throw new Error('Please enable popups in your browser in order to login');
		} else throw new Error(error);
	}
};

export const getSsoCustomer = (ssoCustomers: SsoCustomer[], emailDomain: string): CustomerSsoDetails => {
	if (emailDomain && ssoCustomers) {
		const customersWithSsoProperties = ssoCustomers.filter(
			(ssoCustomer) => ssoCustomer.ssoProperties !== undefined && ssoCustomer.ssoProperties !== ''
		);
		const customersWithDomains: CustomerSsoDetails[] = customersWithSsoProperties.map((ssoCustomer) => {
			const parsedProperties = JSON.parse(ssoCustomer.ssoProperties);
			return {
				customerId: ssoCustomer.customerId,
				customerName: ssoCustomer.customerName,
				scope: parsedProperties.scope,
				clientId: parsedProperties.clientId,
				domain: parsedProperties.domain,
				authority: parsedProperties.authority
			};
		});
		return customersWithDomains.find((x) => x.domain.includes(emailDomain));
	}
	return null;
};

const getRedirectAppUrl = () => {
	return localStorage.getItem(sessionKeys.redirectAppUrl);
};

const removeRedirectAppUrl = () => {
	return localStorage.removeItem(sessionKeys.redirectAppUrl);
};
